import React from 'react';
import message from '@assets/message.png';
import { useTranslation } from 'react-i18next';
import SuccessPageComponents from './success-page.components';
import { useParamsContext } from '../../params/params-context';

const { Container, Icon, Title, StyledText } = SuccessPageComponents;
const SuccessPage: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { portalType } = useParamsContext();
  return (
    <Container>
      <Icon src={message} alt={t('successPage.imgAlt')} />
      <Title
        tParams={{
          tKey: [`successPage.${portalType}.title`, 'successPage.title']
        }}
      />
      <StyledText
        tParams={{
          tKey: [`successPage.${portalType}.message`, 'successPage.message']
        }}
      />
    </Container>
  );
};

export default SuccessPage;
